export function DukareeHero() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center md:space-x-12 space-y-8 md:space-y-0">
      <div className="flex-1">
        <span className="text-sm uppercase tracking-wider bg-gray-200 px-2 py-1 rounded-full text-gray-700">
          Ethos Tech Hub Limited
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-4">
          Ethos | Sales and Distribution
        </h1>
        <p className="mt-4 text-gray-600 text-lg">
          Ethos Sales and Distribution empowers field sales teams and managers
          with a modern, intuitive mobile interface built to streamline the
          entire sales process. From order capturing to route planning, Dukaree
          makes field operations faster, smarter, and more efficient — all in
          real time.
        </p>
      </div>
      <div className="flex-1">
        <img
          src="/images/dukaree/DukareeApplicationFeatures.png"
          alt="illustration"
          className="w-48 mx-auto" // Adjust the number to fit your design
        />
      </div>
    </section>
  );
}
